import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { RolePermission, PermissionLevel } from "./types";

export const useRolePermissions = (roleId: string | null) => {
  return useQuery({
    queryKey: ["role_permissions", roleId],
    queryFn: async (): Promise<RolePermission[]> => {
      if (!roleId) return [];
      // TODO: Wire to real permissions API when available
      return [];
    },
    enabled: !!roleId,
  });
};

export const useUpdatePermissions = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ 
      roleId, 
      permissions 
    }: { 
      roleId: string, 
      permissions: { resource_id: string, permission: PermissionLevel }[] 
    }) => {
      // TODO: Wire to real permissions API when available
      throw new Error("Permissions API not yet available");
    },
    onSuccess: (_, variables) => {
      toast.success("Permissions updated successfully");
      queryClient.invalidateQueries({ queryKey: ["role_permissions", variables.roleId] });
    },
    onError: (error) => {
      toast.error(`Failed to update permissions: ${error.message}`);
    }
  });
};
